import React from 'react';
import ScrollableCardModal from './ScrollableCardModal';

const ScrollableClubCardModal = ({ clubId, isOpen, onClose, onConnectionChange }) => {
  return (
    <ScrollableCardModal
      cardType="club"
      cardId={clubId}
      isOpen={isOpen}
      onClose={onClose}
      onConnectionChange={onConnectionChange}
    />
  );
};

export default ScrollableClubCardModal;
